var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5186 19.9505C16.8292 20.1137 17.1923 19.85 17.1329 19.504L15.9832 12.793L20.8571 8.04214C21.1084 7.7972 20.9696 7.37023 20.6222 7.31991L13.8872 6.34496L10.8725 0.236076C10.717 -0.078692 10.2683 -0.078692 10.1129 0.236076L7.09543 6.34133L0.363145 7.31964C0.0157684 7.36997 -0.123016 7.79695 0.128309 8.04187L5.00353 12.7923L3.85257 19.5033C3.7932 19.8492 4.15635 20.113 4.46687 19.9497L10.4954 16.7803L16.5186 19.9505Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatured);
export default __webpack_public_path__ + "static/media/featured.bcf9ed14a2ed9c849ab5229070c39ff6.svg";
export { ForwardRef as ReactComponent };